<template lang="pug">
v-app
  AppBar
  NavigationDrawer(v-if="$vuetify.breakpoint.smAndDown")
  Alert(v-show="$route.path !== '/contato'")
  v-main
    router-view
  Footer
</template>

<script>
export default {
  components: {
    Alert: () => import('./components/Alert'),
    AppBar: () => import('./components/AppBar'),
    Footer: () => import('./components/Footer'),
    NavigationDrawer: () => import('./components/NavigationDrawer')
  }
}
</script>

<style lang="sass">
.v-application
  .text-h1,
  .text-h2,
  .text-h3,
  .text-h4,
  .text-h5,
  .text-h6,
  .text-subtitle-1,
  .text-subtitle-2,
  .text-body-1,
  .text-body-2,
  .text-button,
  .text-caption,
  .text-overline
    .ibm, .ibm *
      font-family: 'IBM Plex Serif', serif !important
    .heebo, .heebo *
      font-family: 'Heebo', sans-serif !important
  .ibm, .ibm *
    font-family: 'IBM Plex Serif', serif !important
  .heebo, .heebo *
    font-family: 'Heebo', sans-serif !important

.banner
  background-size: cover
  background-position: center
  transition: background-image 1s ease

.banner1
  @extend .banner
  background-color: black
  background-image: url(assets/banners/erudio_banner1.png)

.banner2
  @extend .banner
  background-image: url(assets/banners/erudio_banner2.png)

.banner3
  @extend .banner
  background-color: black
  background-image: url(assets/banners/erudio_banner3.png)

.banner4
  @extend .banner
  background-color: var(--v-primary-base)
  background-image: url(assets/banners/erudio_banner4.png)

.simple-management
  background-size: contain
  background-position: center
  background-image: url(assets/illustrations/simple_management.svg)

.VueCarousel-navigation
  &-button
    padding: 0 !important
    margin-top: -30px
    width: 24px !important
    height: 44px !important
    transition: transform .1s cubic-bezier(0.4, 0.0, 0.2, 1) !important


  &-next
    background: url(./assets/chevron-right.svg) !important
    &:hover
      transform: translateY(-50%) translateX(100%) scale(1.2) !important

  &-prev
    background: url(./assets/chevron-left.svg) !important
    &:hover
      transform: translateY(-50%) translateX(-100%) scale(1.2) !important

.video-container
  position: relative
  padding-bottom: 56.25%
  padding-top: 30px
  height: 0
  overflow: hidden

.video-container iframe,
.video-container object,
.video-container embed
  position: absolute
  top: 0
  left: 0
  width: 100%
  height: 100%

.background-transition
  transition: background-image 3000ms ease

.fade-enter-active
  transition: all .5s ease
.fade-leave-active
  transition: all .1s ease
.fade-enter, .fade-leave-to
  opacity: 0

.slow-fade-enter-active
  transition: all 2s ease
.slow-fade-leave-active
  transition: all .5s ease
.slow-fade-enter, .slow-fade-leave-to
  opacity: 0

.scroll-from-left-slow-enter-active,
.scroll-from-right-slow-enter-active,
.scroll-from-bottom-slow-enter-active
  transition: all 1s ease
.scroll-from-left-slow-leave-active,
.scroll-from-right-slow-leave-active,
.scroll-from-bottom-slow-leave-active
  transition: all .5s ease

.scroll-from-left-normal-enter-active,
.scroll-from-right-normal-enter-active,
.scroll-from-bottom-normal-enter-active
  transition: all .6s ease
.scroll-from-left-normal-leave-active,
.scroll-from-right-normal-leave-active,
.scroll-from-bottom-normal-leave-active
  transition: all .5s ease

.scroll-from-left-normal-enter, .scroll-from-left-normal-leave-to,
.scroll-from-left-slow-enter, .scroll-from-left-slow-leave-to
  opacity: 0
  will-change: transform, opacity
  transform: translateX(-50%)

.scroll-from-right-normal-enter, .scroll-from-right-normal-leave-to,
.scroll-from-right-slow-enter, .scroll-from-right-slow-leave-to
  opacity: 0
  will-change: transform, opacity
  transform: translateX(50%)

.scroll-from-bottom-normal-enter, .scroll-from-bottom-normal-leave-to,
.scroll-from-bottom-slow-enter, .scroll-from-bottom-slow-leave-to
  opacity: 0
  transform: translateY(50%)
  will-change: transform, opacity

.break-word
  word-break: break-word
</style>
